
import { toast as sonnerToast } from "sonner";
import { CheckIcon, XIcon, AlertTriangleIcon } from "lucide-react";
import { getThemeVariable } from "@/utils/theme";

const getVar = (name: string) => getThemeVariable(name);

export type ToastVariant = "default" | "success" | "destructive" | "warning";

export interface ToastOptions {
  title?: string;
  description: string;
  duration?: number;
  variant?: ToastVariant;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const toast = ({ title, description, duration = 2500, variant = "default", action }: ToastOptions) => {
  const color =
    variant === "success"
      ? getVar('successColor')
      : variant === "destructive"
        ? getVar('errorColor')
        : variant === "warning"
          ? getVar('warningColor')
          : '';
  const textColor = getVar('textPrimaryColor');

  const options = {
    duration,
    description,
    style: color
      ? {
          backgroundColor: color,
          borderColor: color,
          color: textColor,
        }
      : undefined,
    className: color ? '' : getToastClassName(variant),
    onClick: (_e: any, t: { id: string }) => sonnerToast.dismiss(t.id),
    action: action ? {
      label: action.label,
      onClick: action.onClick,
    } : undefined
  };

  switch (variant) {
    case "success":
      return sonnerToast(title || "Successo", {
        ...options,
        description,
        icon: <CheckIcon className="h-4 w-4" style={{ color: textColor }} />,
      });
    case "destructive":
      return sonnerToast.error(title || "Errore", {
        ...options,
        description,
        icon: <XIcon className="h-4 w-4" style={{ color: textColor }} />,
      });
    case "warning":
      return sonnerToast.warning(title || "Attenzione", {
        ...options,
        description,
        icon: <AlertTriangleIcon className="h-4 w-4" style={{ color: textColor }} />,
      });
    default:
      return sonnerToast(title || "", {
        ...options,
        description,
      });
  }
};

const getToastClassName = (variant: ToastVariant): string => {
  switch (variant) {
    case "success":
      return "bg-spesa-green-500 text-white border-spesa-green-600";
    case "destructive":
      return "bg-red-500 text-white border-red-600";
    case "warning":
      return "bg-amber-500 text-white border-amber-600";
    default:
      return ""; // Default style handled by Sonner
  }
};
